import { Fragment, useState } from 'react'
import { Dialog, Menu, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import { DotsVerticalIcon } from '@heroicons/react/solid'
import { NavLink } from 'react-router-dom';
import firebase from 'firebase/app';

import defaultImg from '../../../images/default.png';

//functions
import { searchData } from './components/search/searchData';


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ContactsSlide({
  contacts, 
  open,
  setOpen, 
  setProfile,
  setLIurl,
  setInterests,
  setContentGen,
  setFoundInts,
  setDocId

}) {
  //const [open, setOpen] = useState(true)

  const [contactData, setContactData] = useState()

  const handleClick = (person) =>{
    const lastsearchedProfile = {
        profile_pic_url: person?.contactImg.includes("proxycurl") ? defaultImg :person?.contactImg,
        full_name: person?.contactName,
        first_name: person?.contactFirstName,
        last_name: person?.contactLastName, 
        headline: person?.contactHeadline,
        city: person?.contactCity,
        experiences:[{company: person?.contactCompany}],
        summary: person?.contactSummary,
    }

    setProfile(lastsearchedProfile)
    setLIurl(person?.contactLinkdinUrl)
    setInterests(person?.contactInterest)
    setContentGen(person?.message)
    setFoundInts(person?.contactContent)
    setDocId(person?.docId)
  }

  const handleDelete = (person) => {

    firebase.firestore()
    .collection('organizations')
    .doc(person.authorCompany)
    .collection('searchedContactLastFive')
    .doc(person.authorID)
    .collection('searchedContact')
    .doc(person.docId)
    .delete().then(() => {
      console.log("Document successfully deleted!");
    }).catch((error) => {
        console.error("Error removing document: ", error);
    });
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" static className="fixed inset-0 overflow-hidden" open={open} onClose={setOpen}>
        <div className="absolute inset-0 overflow-hidden">
          <Dialog.Overlay className="absolute inset-0" />

          <div className="fixed inset-y-0 right-0 pl-10 max-w-full flex sm:pl-16">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <div className="w-screen max-w-md">
                <div className="h-full flex flex-col bg-white shadow-xl overflow-y-scroll">
                  <div className="p-6">
                    <div className="flex items-start justify-between">
                      <Dialog.Title className="text-lg font-medium text-gray-900">Prospected</Dialog.Title>
                      <div className="ml-3 h-7 flex items-center">
                        <button
                          className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500"
                          onClick={() =>{ setOpen(false); setContactData(false)}}
                        >
                          <span className="sr-only">Close panel</span>
                          <XIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="border-b border-gray-200">
                    <div className="px-2 mb-2">
                        <input
                            type="text"
                            name="text"
                            className=" shadow-sm p-2 focus:outline-none focus:ring focus:border-indigo-300 block w-full sm:text-sm border-blue-300 border-2 rounded-md"
                            placeholder="Search"
                            autoComplete='off'
                            onChange={(e) => searchData(e.target.value, contacts, setContactData)}
                        />
                    </div>
                  </div>
                  {!contactData ?
                  <ul className="flex-1 divide-y divide-gray-200 overflow-y-auto">
                    {contacts?.map((person, index) => (
                      <li key={index}>
                        <div className="relative group py-6 px-5 flex items-center">
                            <div className="absolute inset-0 group-hover:bg-gray-50" aria-hidden="true" />
                            <div className="flex-1 flex items-center min-w-0 relative">
                              <span className="flex-shrink-0 inline-block relative">
                                  {person.contactImg !== ""?
                                    //<img className="h-10 w-10 rounded-full" src={person.contactImg} alt="" />
                                    (person.contactImg.includes("proxycurl") ?
                                    <img 
                                    src={defaultImg} 
                                    alt='searched' 
                                    className="rounded-full p-4 h-20"
                                    />
                                    :
                                    <img 
                                    src={person.contactImg} 
                                    alt='searched' 
                                    className="rounded-full p-4 h-20"
                                    />
                                    )
                                    :
                                    <img className="rounded-full p-4 h-20" src={defaultImg} alt="" />
                                  }
                                {/* <span
                                  className={classNames(
                                    person.status === 'online' ? 'bg-green-400' : 'bg-gray-300',
                                    'absolute top-0 right-0 block h-2.5 w-2.5 rounded-full ring-2 ring-white'
                                  )}
                                  aria-hidden="true"
                                /> */}
                              </span>
                              <div className="ml-4 truncate">
                                <p className="text-sm font-medium text-gray-900 truncate">{person.contactName}</p>
                                <p className="text-sm text-gray-500 truncate">{person.contactRole}</p>
                              </div>
                            </div>
                          <Menu as="div" className="ml-2 flex-shrink-0 relative inline-block text-left">
                            {({ open }) => (
                              <>
                                <Menu.Button className="group relative w-8 h-8 bg-white rounded-full inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                  <span className="sr-only">Open options menu</span>
                                  <span className="flex items-center justify-center h-full w-full rounded-full">
                                    <DotsVerticalIcon
                                      className="w-5 h-5 text-gray-400 group-hover:text-gray-500"
                                      aria-hidden="true"
                                    />
                                  </span>
                                </Menu.Button>
                                <Transition
                                  show={open}
                                  as={Fragment}
                                  enter="transition ease-out duration-100"
                                  enterFrom="transform opacity-0 scale-95"
                                  enterTo="transform opacity-100 scale-100"
                                  leave="transition ease-in duration-75"
                                  leaveFrom="transform opacity-100 scale-100"
                                  leaveTo="transform opacity-0 scale-95"
                                >
                                  <Menu.Items
                                    static
                                    className="origin-top-right absolute z-10 top-0 right-9 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                                  >
                                    <div className="py-1">
                                      <Menu.Item>
                                        {({ active }) => (
                                          <NavLink
                                            exact
                                            to={'/contact/' + person.id}
                                            className={classNames(
                                              active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                              'block px-4 py-2 text-sm'
                                            )}
                                            style={{textDecoration: 'none'}}
                                          >
                                            View profile
                                            </NavLink>
                                        )}
                                      </Menu.Item>
                                      <Menu.Item>
                                        {({ active }) => (
                                          <p
                                            className={classNames(
                                              active ? 'bg-gray-100 text-green-900' : 'text-green-700',
                                              'block px-4 py-2 text-sm cursor-pointer'
                                            )}
                                            onClick={()=> handleClick(person)}
                                          >
                                            Create a message
                                          </p>
                                        )}
                                      </Menu.Item>
                                      <Menu.Item>
                                        {({ active }) => (
                                          <p
                                            className={classNames(
                                              active ? 'bg-gray-100 text-red-900' : 'text-red-700',
                                              'block px-4 py-2 text-sm cursor-pointer'
                                            )}
                                            onClick={()=> handleDelete(person)}
                                          >
                                            Delete contact
                                          </p>
                                        )}
                                      </Menu.Item>
                                    </div>
                                  </Menu.Items>
                                </Transition>
                              </>
                            )}
                          </Menu>
                        </div>
                      </li>
                    ))}
                  </ul>
                  :
                  <ul className="flex-1 divide-y divide-gray-200 overflow-y-auto">
                    {contactData?.map((person, index) => (
                      <li key={index}>
                        <div className="relative group py-6 px-5 flex items-center">
                            <div className="absolute inset-0 group-hover:bg-gray-50" aria-hidden="true" />
                            <div className="flex-1 flex items-center min-w-0 relative">
                              <span className="flex-shrink-0 inline-block relative">
                                  {person.contactImg !== ""?
                                    //<img className="h-10 w-10 rounded-full" src={person.contactImg} alt="" />
                                    (person.contactImg.includes("proxycurl") ?
                                    <img 
                                    src={defaultImg} 
                                    alt='searched' 
                                    className="rounded-full p-4 h-20"
                                    />
                                    :
                                    <img 
                                    src={person.contactImg} 
                                    alt='searched' 
                                    className="rounded-full p-4 h-20"
                                    />
                                    )
                                    :
                                    <img className="rounded-full p-4 h-20" src={defaultImg} alt="" />
                                  }
                                {/* <span
                                  className={classNames(
                                    person.status === 'online' ? 'bg-green-400' : 'bg-gray-300',
                                    'absolute top-0 right-0 block h-2.5 w-2.5 rounded-full ring-2 ring-white'
                                  )}
                                  aria-hidden="true"
                                /> */}
                              </span>
                              <div className="ml-4 truncate">
                              <p className="text-sm font-medium text-gray-900 truncate">{person.contactName}</p>
                                <p className="text-sm text-gray-500 truncate">{person.contactRole}</p>
                              </div>
                            </div>
                          <Menu as="div" className="ml-2 flex-shrink-0 relative inline-block text-left">
                            {({ open }) => (
                              <>
                                <Menu.Button className="group relative w-8 h-8 bg-white rounded-full inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                  <span className="sr-only">Open options menu</span>
                                  <span className="flex items-center justify-center h-full w-full rounded-full">
                                    <DotsVerticalIcon
                                      className="w-5 h-5 text-gray-400 group-hover:text-gray-500"
                                      aria-hidden="true"
                                    />
                                  </span>
                                </Menu.Button>
                                <Transition
                                  show={open}
                                  as={Fragment}
                                  enter="transition ease-out duration-100"
                                  enterFrom="transform opacity-0 scale-95"
                                  enterTo="transform opacity-100 scale-100"
                                  leave="transition ease-in duration-75"
                                  leaveFrom="transform opacity-100 scale-100"
                                  leaveTo="transform opacity-0 scale-95"
                                >
                                  <Menu.Items
                                    static
                                    className="origin-top-right absolute z-10 top-0 right-9 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                                  >
                                    <div className="py-1">
                                      <Menu.Item>
                                        {({ active }) => (
                                          <NavLink
                                            exact
                                            to={'/contact/' + person.id}
                                            className={classNames(
                                              active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                              'block px-4 py-2 text-sm'
                                            )}
                                            style={{textDecoration: 'none'}}
                                          >
                                            View profile
                                            </NavLink>
                                        )}
                                      </Menu.Item>
                                      <Menu.Item>
                                        {({ active }) => (
                                          <p
                                            className={classNames(
                                              active ? 'bg-gray-100 text-green-900' : 'text-green-700',
                                              'block px-4 py-2 text-sm cursor-pointer'
                                            )}
                                            onClick={()=> handleClick(person)}
                                          >
                                            Create a message
                                          </p>
                                        )}
                                      </Menu.Item>
                                      <Menu.Item>
                                        {({ active }) => (
                                          <p
                                            className={classNames(
                                              active ? 'bg-gray-100 text-red-900' : 'text-red-700',
                                              'block px-4 py-2 text-sm cursor-pointer'
                                            )}
                                            onClick={()=> handleDelete(person)}
                                          >
                                            Delete contact
                                          </p>
                                        )}
                                      </Menu.Item>
                                    </div>
                                  </Menu.Items>
                                </Transition>
                              </>
                            )}
                          </Menu>
                        </div>
                      </li>
                    ))}
                  </ul>}
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}